import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Game } from '../../../Core'

import * as indicatorsSelectors from '../../Indicators/indicators.selectors'
import * as audioActions from '../../../Core/Game/AudioContainer/audio.actions'

import * as actions from '../quizzes.actions'

/**
 *  Pop up showed when click wildcard button
 */
class WildcardPopup extends React.Component {
  /**
   *  Component constructor.
   */
  constructor(props) {
    super(props)
    this.state = {}
  }

  removePopup(cancel) {
    const { buyWildcard, useWildcard, counters, removePopup } = this.props

    const wildcard = counters.wc
    if (!cancel) {
      wildcard ? useWildcard() : buyWildcard()
    }
    removePopup('wildcard_popup')
  }

  render() {
    const {
      counters: { wc: wildcard },
      indicators: { antimatter },
      addHowlSound,
    } = this.props
    const WILDCARD_PRICE = 20
    const cancel = true

    const noCredits = !wildcard && antimatter < WILDCARD_PRICE
    const canAccept = wildcard || antimatter >= WILDCARD_PRICE

    return (
      <div className="popup--game">
        <div className="popup--box">
          <div className="popup--box__canvas">
            <div className="popup--heading">
              <FormattedMessage id={wildcard ? 'questions.useWildcard' : 'questions.buyWildcard'} />
            </div>
            {!wildcard ? (
              <div className="popup--text">
                <FormattedMessage
                  id="questions.wildcard_price"
                  values={{ quantity: WILDCARD_PRICE }}
                />{' '}
                <span className="icon-antimateria"> </span>
              </div>
            ) : null}
            {noCredits && (
              <span className="red" style={{ paddingBottom: '12px' }}>
                <FormattedMessage id="questions.wildcard_no_credits" />
              </span>
            )}
            <div className="popup--buttons">
              <div
                onClick={() => {
                  this.removePopup(cancel)
                  addHowlSound('button_click_icon')
                }}
                className="btn--shape shape--blue"
              >
                <div className="btn--shape__canvas">
                  <FormattedMessage id="questions.cancel" />
                </div>
              </div>
              <div
                className={`btn--shape shape--blue ${noCredits ? 'disabled' : ''}`}
                onClick={() => {
                  canAccept && this.removePopup()
                  addHowlSound('button_click')
                }}
              >
                <div className="btn--shape__canvas">
                  <FormattedMessage id="questions.accept" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    useWildcard: bindActionCreators(actions.useWildcard, dispatch),
    buyWildcard: bindActionCreators(actions.buyWildcard, dispatch),
    removePopup: bindActionCreators(Game.actions.removePopup, dispatch),
    addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
  }
}
const mapStateToProps = (state) => {
  return {
    counters: indicatorsSelectors.getCountersData(state),
    indicators: indicatorsSelectors.getUserData(state),
  }
}

WildcardPopup.propTypes = {
  useWildcard: PropTypes.func,
  buyWildcard: PropTypes.func,
  removePopup: PropTypes.func,
  counters: PropTypes.object,
  indicators: PropTypes.object,
  addHowlSound: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(WildcardPopup))
